import { crayonIcon } from "../../../../assets/svgs/icons/icons.svg";
import { IEtablissement } from '../../../../schemas-and-types/etablissement/etablissemen.schema';
import Button from "../../../global/Button/Button";
import InformationSection from "../../../global/InformationSection/InformationSection";

import { useTranslation } from "react-i18next";
import styles from "./InformationEtabRecap.module.scss";
import { formatPhoneNumber } from "./utils";

type Props = {
  canUpdate: boolean;
  setIsInfoEtabModification?: React.Dispatch<React.SetStateAction<boolean>>
  etablissement: IEtablissement
};
export default function InformationEtabRecap(props: Props) {
  const { canUpdate, etablissement, setIsInfoEtabModification } = props;
  const { t } = useTranslation()

  function onClickModifier() {
    setIsInfoEtabModification && setIsInfoEtabModification(true)
  }

  return (
    <article className={styles.informationEtab}>
      <header>
        <h2>{t('validation.informationsEtablissement.title')} *</h2>
        {canUpdate && false && (
          <Button
            buttonBackGroundColor="white"
            textColor="dark"
            type="button"
            icon={crayonIcon}
            text={t('common.edit')}
            onClick={onClickModifier}
          />
        )}
      </header>
      <main>
        <article className={styles.informationEtab__top}>
          <section className={styles.informationEtab__top__left}>
            <section>
              <InformationSection label={t('validation.typeEtabli')} text={etablissement?.type ?? '-'} />
            </section>
            <section>
              <InformationSection
                label={t('validation.nameEtablissement')}
                text={etablissement?.name ?? '-'}
              />
              <InformationSection
                label={t('validation.addressEtablissement')}
                text={etablissement?.localisation?.address ?? '-'}
              />
            </section>
            <section>
              <InformationSection

                label={t('validation.accessEtablissement')}
                text={etablissement?.information_access ?? '-'}
                maxSectionWidth="684px"
              />
            </section>
          </section>
          <section
            className={styles.informationEtab__top__separationLine}
          ></section>
          <section className={styles.informationEtab__top__right}>
            <section>
              <InformationSection
                label={t('validation.regionEtablissement')}
                text={etablissement?.information_regional?.region ?? '-'}
              />
            </section>
            <section>
              <InformationSection
                label={t('validation.drName')}
                text={etablissement?.information_regional?.nom_dr ?? '-'}
              />
              <InformationSection
                label={t('validation.drFirstName')}
                text={etablissement?.information_regional?.prenom_dr ?? '-'}
              />
            </section>
          </section>
        </article>

        <section className={styles.informationEtab__bottom}>
          {/* <article className={styles.informationEtab__bottom__DE}>
            <h2>{t('validation.titleInfoDe')} *</h2>
            <main>
              <section>
                <InformationSection
                  label={t('validation.deName')}
                  text={etablissement?.information_DE?.nom_de ?? '-'}
                />
                <InformationSection label="Email" text={etablissement?.information_DE?.email_de ?? '-'} />
              </section>
              <section>
                <InformationSection
                  label={t('validation.deFirstName')}
                  text={etablissement?.information_DE?.prenom_de ?? '-'}
                />
                <InformationSection label={t('validation.dePhone')} text={formatPhoneNumber(etablissement?.information_DE?.phone_de) ?? '-'} />
              </section>
            </main>
          </article> */}
          <article className={styles.informationEtab__bottom__REF}>
            <h3>{t('validation.referentInfoTitle')} *</h3>
            <main>
              <section>
                <InformationSection
                  label={t('validation.referentName')}
                  text={etablissement?.information_referent?.nom_referent ?? '-'}
                />
                <InformationSection label={t('validation.referentEmail')} text={etablissement?.information_referent?.email_referent ?? '-'} />
              </section>
              <section>
                <InformationSection
                  label={t('validation.referentFirstName')}
                  text={etablissement?.information_referent?.prenom_referent ?? '-'}
                />
                <InformationSection label={t('validation.referentPhone')} text={formatPhoneNumber(etablissement?.information_referent?.phone_referent as string) ?? '-'} />
              </section>
            </main>
          </article>
        </section>
      </main>
    </article>
  );
}
